import { PaginatedSearch } from "../util/pagination";

export const agentQueries = {
  get: (sessionId: string, agentId: string, momentId: number | null = null) => [
    "agent",
    sessionId,
    agentId,
    momentId,
  ],
  getPublicState: (
    sessionId: string,
    agentId: string,
    momentId: number | null = null
  ) => ["agentPublicState", sessionId, agentId, momentId],
  getPrivateState: (
    sessionId: string,
    agentId: string,
    momentId: number | null = null
  ) => ["agentPrivateState", sessionId, agentId, momentId],
  getPresentation: (
    sessionId: string,
    agentId: string,
    momentId: number | null = null
  ) => ["agentPresentation", sessionId, agentId, momentId],
  getMomentList: (sessionId: string, agentId: string) => [
    "agentMomentList",
    sessionId,
    agentId,
  ],
  getCloneTree: (sessionId: string, agentId: string) => [
    "agentCloneTree",
    sessionId,
    agentId,
  ],
};

export const organizationServiceQueries = {
  all: () => ["organizationServices"],
};

export const playgroundQueries = {
  seed: (sessionId: string, agentId: string, momentId: number) => [
    "playgroundSeed",
    sessionId,
    agentId,
    momentId,
  ],
};

export const eventStreamQueries = {
  get: (sessionId: string, agentId: string, reverse: boolean = false) => [
    "event_streams",
    "get",
    { sessionId, agentId, reverse },
  ],
  getDetail: (sessionId: string, agentId: string, momentId: number | null) => [
    "event_streams",
    "get_detail",
    { sessionId, agentId, momentId },
  ],
};

export const messageTypeQueries = {
  list: () => ["message-types", "get"],
};

export const sessionQueries = {
  get: (sessionId: string) => ["session", sessionId],
  getParents: (sessionId?: string) => ["session-parents", sessionId],
  getChildren: (sessionId?: string) => ["session-children", sessionId],
  getTokenUsage: (sessionId: string) => ["session-token-usage", sessionId],
  getMomentUsage: (sessionId: string, momentId: number) => [
    "session-moment-usage",
    sessionId,
    momentId,
  ],
};

export const apiKeyQueries = {
  list: (
    paginatedSearch: PaginatedSearch<{ organization?: string; notes?: string }>
  ) => ["api_keys", "get", { paginatedSearch }],
};

export const apiRequestQueries = {
  list: (
    paginatedSearch: PaginatedSearch<{
      onlyFailed: boolean;
      organization?: string;
      fromDateTime?: number;
      toDateTime?: number;
    }>
  ) => ["apiRequest", "get", { paginatedSearch }],
  get: ({
    requestId,
    organization,
  }: {
    requestId: string;
    organization: string;
  }) => ["apiRequest", requestId, organization],
};

export const projectQueries = {
  all: () => ["projects"],
  list: (
    paginatedSearch: PaginatedSearch<{
      organization?: string;
      includeArchived: boolean;
    }>
  ) => ["projects", "get", { paginatedSearch }],
  get: (projectId: string) => ["project", projectId],
  users: (projectId: string) => ["projectUsers", projectId],
  // BAGEL-312: per-project M2M credentials list (no secret).
  m2mCredentials: (projectId: string) => [
    "project",
    projectId,
    "m2m-credentials",
  ],
  // BAGEL-448: per-project self-serve OIDC issuer list.
  oidcIssuers: (projectId: string) => ["project", projectId, "oidc-issuers"],
  // Entitlement: store-backed player sessions, set up by the customer.
  entitlement: (projectId: string) => ["project", projectId, "entitlement"],
  entitlementAudit: (projectId: string) => [
    "project",
    projectId,
    "entitlement",
    "audit",
  ],
};

export const usageQueries = {
  getUsageBetween: ({
    organization,
    startDate,
    endDate,
  }: {
    organization?: string;
    startDate: string;
    endDate: string;
  }) => ["usage", startDate, endDate, organization],
};

export const widgetTokenQueries = {
  getUserTableWidgetToken: () => ["users", "get-widget-token"],
  getAccountWidgetToken: () => ["account", "get-widget-token"],
};

export const agencyTagQueries = {
  list: (organization: string, projectId: string) => [
    "agency-tags",
    organization,
    projectId,
  ],
};
